
import { defineComponent } from 'vue'
import DescriptionList from '@/components/DescriptionList.vue'
import IconPencil from '@/components/IconPencil.vue'
import SecondaryButton from '@/components/SecondaryButton.vue'

export default defineComponent({
  components: {
    DescriptionList,
    IconPencil,
    SecondaryButton
  },

  props: {
    baseInterestRate: {
      required: true,
      type: Number
    },

    endDate: {
      required: true,
      type: String
    },

    startDate: {
      required: true,
      type: String
    },

    loanAmount: {
      required: true,
      type: String
    },

    margin: {
      required: true,
      type: Number
    }
  },

  emits: ['editLoan']
})
